// ============================================================
// 📁 projects.js — Central data file for all portfolio projects
// ============================================================

// ============================================================
// 🖼️ WEB PROJECT THUMBNAILS
// ============================================================
import vsbp from "../assets/projectsImg/VSBPImg/VSBPHome.png";
import yammiverse from "../assets/projectsImg/yammiverse.png";
import bodp from "../assets/projectsImg/bloodAndOrganDonationsImg/jeevandaancareHome.png";
import textutils from "../assets/projectsImg/textUtilksImg/textutils.png";
import SpiceCraft from "../assets/projectsImg/spiceCraftTradersImg/SpiceCraft Traders Home.png";
import RestaurantMain from "../assets/projectsImg/restaurantImg/restaurant home.png";
import CoachingMain from "../assets/projectsImg/coachingWebsitesimg/CoachingWebsiite Home.png";
import tiffinDelivery from "../assets/projectsImg/tiffinDeliveryImg/TiffinDeliveryHome.png";
import foodmitra from "../assets/projectsImg/foodmitra/foodmitra.png";
import Scalegate from "../assets/projectsImg/ScaleGateDemo.jpg";

// ============================================================
// 🖼️ MOBILE APP THUMBNAILS
// ============================================================
import parkEasyFront from "../assets/AppImg/ParkEasyAdmin/ParkEasyFront.jpg";
import parkingapp from "../assets/AppImg/parkingapp.jpeg";
import FoodMitraApp from "../assets/AppImg/FoodMitra/FoodMitraCustumer.jpeg";
import FoodMitraDeliveryApp from "../assets/AppImg/FoodMitraDelivery/FoodMitraDeliveryPartner.jpeg";
import FoodMitraTiffinHouseApp from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraHouseTiffin.jpeg";

// ============================================================
// 🖼️ GALLERY — Blood & Organ Donation
// ============================================================
import bodp1 from "../assets/projectsImg/bloodAndOrganDonationsImg/Blood And Organ Donation 2.png";
import bodp2 from "../assets/projectsImg/bloodAndOrganDonationsImg/Blood And Organ Donation 3.png";
import bodp3 from "../assets/projectsImg/bloodAndOrganDonationsImg/Blood And Organ Donation hospitals.png";
import bodp4 from "../assets/projectsImg/bloodAndOrganDonationsImg/Blood And Organ Donation About.png";
import bodp5 from "../assets/projectsImg/bloodAndOrganDonationsImg/Blood And Organ Donation Footers.png";
import bodp6 from "../assets/projectsImg/bloodAndOrganDonationsImg/loadinghompeage.png";

// ============================================================
// 🖼️ GALLERY — TextUtils
// ============================================================
import textutils1 from "../assets/projectsImg/textUtilksImg/Textutils1.png";
import textutils2 from "../assets/projectsImg/textUtilksImg/TextUtils 2.png";
import textutilshome from "../assets/projectsImg/textUtilksImg/Textutils home.png";

// ============================================================
// 🖼️ GALLERY — SpiceCraft Traders
// ============================================================
import SpiceCraft1 from "../assets/projectsImg/spiceCraftTradersImg/SpiceCraft Traders 1.png";
import SpiceCraft2 from "../assets/projectsImg/spiceCraftTradersImg/SpiceCraft Traders 2.png";
import SpiceCraft3 from "../assets/projectsImg/spiceCraftTradersImg/SpiceCraft Traders 3.png";
import SpiceCraft4 from "../assets/projectsImg/spiceCraftTradersImg/SpiceCraft Traders 4.png";
import SpiceCraft5 from "../assets/projectsImg/spiceCraftTradersImg/SpiceCraft Traders 5.png";
import SpiceCraft6 from "../assets/projectsImg/spiceCraftTradersImg/SpiceCraft Traders 6.png";

// ============================================================
// 🖼️ GALLERY — Restaurant
// ============================================================
import RestaurantMenu from "../assets/projectsImg/restaurantImg/restaurant 1.png";
import RestaurantChef from "../assets/projectsImg/restaurantImg/restaurant 2.png";
import RestaurantGallery from "../assets/projectsImg/restaurantImg/restaurant 3.png";
import RestaurantAbout from "../assets/projectsImg/restaurantImg/restaurant 4.png";
import UpcomingEvents from "../assets/projectsImg/restaurantImg/restaurant 5.png";
import RestaurantContact from "../assets/projectsImg/restaurantImg/restaurant 6.png";
import RestaurantFooter from "../assets/projectsImg/restaurantImg/restaurant 7.png";

// ============================================================
// 🖼️ GALLERY — Coaching
// ============================================================
import CoachingHomeSecond from "../assets/projectsImg/coachingWebsitesimg/CoachingWebsiite Home 1.png";
import CoachingCourses from "../assets/projectsImg/coachingWebsitesimg/CoachingWebsiite 2.png";
import CoachingFeatures from "../assets/projectsImg/coachingWebsitesimg/CoachingWebsiite 4.png";
import CoachingTestimonials from "../assets/projectsImg/coachingWebsitesimg/CoachingWebsiite 4.png";

// ============================================================
// 🖼️ GALLERY — Tiffin Delivery
// ============================================================
import TiffinDeliveryUser from "../assets/projectsImg/tiffinDeliveryImg/TiffinDeliveryUser.png";
import TiffinDeliveryAdmindashboard from "../assets/projectsImg/tiffinDeliveryImg/TiffinDelivery1.png";
import TiffinDeliveryCreateAcc from "../assets/projectsImg/tiffinDeliveryImg/TiffinDelivery2.png";
import TiffinDelivery3 from "../assets/projectsImg/tiffinDeliveryImg/TiffinDelivery3.png";
import TiffinDelivery4 from "../assets/projectsImg/tiffinDeliveryImg/TiffinDelivery4.png";
import TiffinDelivery5 from "../assets/projectsImg/tiffinDeliveryImg/TiffinDelivery5.png";
import TiffinDelivery6 from "../assets/projectsImg/tiffinDeliveryImg/TiffinDelivery6.png";
import TiffinDelivery7 from "../assets/projectsImg/tiffinDeliveryImg/TiffinDelivery7.png";

// ============================================================
// 🖼️ GALLERY — Portfolio
// ============================================================
import portfolio1 from "../assets/projectsImg/portfolioImg/portfolio1.png";
import portfolio2 from "../assets/projectsImg/portfolioImg/portfolio2.png";
import portfolio3 from "../assets/projectsImg/portfolioImg/portfolio3.png";
import portfolio4 from "../assets/projectsImg/portfolioImg/portfolio4.png";
import portfolio5 from "../assets/projectsImg/portfolioImg/portfolio5.png";
import portfolio6 from "../assets/projectsImg/portfolioImg/portfolio6.png";
import portfolio7 from "../assets/projectsImg/portfolioImg/portfolio7.png";
import portfolio8 from "../assets/projectsImg/portfolioImg/portfolio8.png";
import portfolio9 from "../assets/projectsImg/portfolioImg/portfolio9.png";
import portfolio10 from "../assets/projectsImg/portfolioImg/portfolio10.png";
import portfolio11 from "../assets/projectsImg/portfolioImg/portfolio11.png";
import portfolio12 from "../assets/projectsImg/portfolioImg/portfolio12.png";
import portfolio13 from "../assets/projectsImg/portfolioImg/portfolio13.png";
import portfolio14 from "../assets/projectsImg/portfolioImg/portfolio14.png";
import portfolio15 from "../assets/projectsImg/portfolioImg/portfolio15.png";
import portfolio16 from "../assets/projectsImg/portfolioImg/portfolio16.png";
import portfolio17 from "../assets/projectsImg/portfolioImg/portfolio17.png";
import portfolio18 from "../assets/projectsImg/portfolioImg/portfolio18.png";
import portfolio19 from "../assets/projectsImg/portfolioImg/portfolio19.png";
import portfolio20 from "../assets/projectsImg/portfolioImg/portfolio20.png";
import portfolio21 from "../assets/projectsImg/portfolioImg/portfolio21.png";
import portfolio22 from "../assets/projectsImg/portfolioImg/portfolio22.png";
import portfolio23 from "../assets/projectsImg/portfolioImg/portfolio23.png";
import portfolio24 from "../assets/projectsImg/portfolioImg/portfolio24.png";
import portfolio25 from "../assets/projectsImg/portfolioImg/portfolio25.png";
import portfolio26 from "../assets/projectsImg/portfolioImg/portfolio26.png";
import portfolio27 from "../assets/projectsImg/portfolioImg/portfolio27.png";
import portfolio28 from "../assets/projectsImg/portfolioImg/portfolio28.png";
import portfolio29 from "../assets/projectsImg/portfolioImg/portfolio29.png";
import portfolio30 from "../assets/projectsImg/portfolioImg/portfolio30.png";
import portfolio31 from "../assets/projectsImg/portfolioImg/portfolio31.png";
import portfolio32 from "../assets/projectsImg/portfolioImg/portfolio32.png";

// ============================================================
// 🖼️ GALLERY — VSBP
// ============================================================
import VSBP1 from "../assets/projectsImg/VSBPImg/VSBP1.png";
import VSBP2 from "../assets/projectsImg/VSBPImg/VSBP2.png";
import VSBP3 from "../assets/projectsImg/VSBPImg/VSBP3.png";
import VSBP4 from "../assets/projectsImg/VSBPImg/VSBP4.png";
import VSBP5 from "../assets/projectsImg/VSBPImg/VSBP5.png";
import VSBP6 from "../assets/projectsImg/VSBPImg/VSBP6.png";
import VSBP7 from "../assets/projectsImg/VSBPImg/VSBP7.png";
import VSBP8 from "../assets/projectsImg/VSBPImg/VSBP8.png";
import VSBP9 from "../assets/projectsImg/VSBPImg/VSBP9.png";
import VSBP10 from "../assets/projectsImg/VSBPImg/VSBP10.png";
import VSBP11 from "../assets/projectsImg/VSBPImg/VSBP11.png";
import VSBP12 from "../assets/projectsImg/VSBPImg/VSBP12.png";
import VSBP13 from "../assets/projectsImg/VSBPImg/VSBP13.png";
import VSBP14 from "../assets/projectsImg/VSBPImg/VSBP14.png";
import VSBP15 from "../assets/projectsImg/VSBPImg/VSBP15.png";
import VSBP16 from "../assets/projectsImg/VSBPImg/VSBP16.png";
import VSBP17 from "../assets/projectsImg/VSBPImg/VSBP17.png";
import VSBP18 from "../assets/projectsImg/VSBPImg/VSBP18.png";
import VSBP19 from "../assets/projectsImg/VSBPImg/VSBP19.png";
import VSBP20 from "../assets/projectsImg/VSBPImg/VSBP20.png";
import VSBP21 from "../assets/projectsImg/VSBPImg/VSBP21.png";
import VSBP22 from "../assets/projectsImg/VSBPImg/VSBP22.png";
import VSBP23 from "../assets/projectsImg/VSBPImg/VSBP23.png";
import VSBP24 from "../assets/projectsImg/VSBPImg/VSBP24.png";
import VSBP25 from "../assets/projectsImg/VSBPImg/VSBP25.png";

// ============================================================
// 🖼️ GALLERY — FoodMitra (Customer app screens)
// ============================================================
import FoodMitra1 from "../assets/projectsImg/foodmitra/foodmitra1.png";
import FoodMitra2 from "../assets/projectsImg/foodmitra/foodmitra2.png";
import FoodMitra3 from "../assets/projectsImg/foodmitra/foodmitra3.png";
import FoodMitra4 from "../assets/projectsImg/foodmitra/foodmitra4.png";
import FoodMitra5 from "../assets/projectsImg/foodmitra/foodmitra5.png";
import FoodMitra6 from "../assets/projectsImg/foodmitra/foodmitra6.png";
import FoodMitra7 from "../assets/projectsImg/foodmitra/foodmitra7.png";
import FoodMitra8 from "../assets/projectsImg/foodmitra/foodmitra8.png";
import FoodMitra9 from "../assets/projectsImg/foodmitra/foodmitra9.png";
import FoodMitra10 from "../assets/projectsImg/foodmitra/foodmitra10.png";
import FoodMitra11 from "../assets/projectsImg/foodmitra/foodmitra11.png";
import FoodMitra12 from "../assets/projectsImg/foodmitra/foodmitra12.png";
import FoodMitra13 from "../assets/projectsImg/foodmitra/foodmitra13.png";
import FoodMitra14 from "../assets/projectsImg/foodmitra/foodmitra14.png";
import FoodMitra15 from "../assets/projectsImg/foodmitra/foodmitra15.png";
import FoodMitra16 from "../assets/projectsImg/foodmitra/foodmitra16.png";
import FoodMitra17 from "../assets/projectsImg/foodmitra/foodmitra17.png";
import FoodMitra18 from "../assets/projectsImg/foodmitra/foodmitra18.png";
import FoodMitra19 from "../assets/projectsImg/foodmitra/foodmitra19.png";

// ============================================================
// 🖼️ GALLERY — FoodMitra Admin
// ============================================================
import FoodMitraAdmin1 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin1.png";
import FoodMitraAdmin2 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin2.png";
import FoodMitraAdmin3 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin3.png";
import FoodMitraAdmin4 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin4.png";
import FoodMitraAdmin5 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin5.png";
import FoodMitraAdmin6 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin6.png";
import FoodMitraAdmin7 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin7.png";
import FoodMitraAdmin8 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin8.png";
import FoodMitraAdmin9 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin9.png";
import FoodMitraAdmin10 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin10.png";
import FoodMitraAdmin11 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin11.png";
import FoodMitraAdmin12 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin12.png";
import FoodMitraAdmin13 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin13.png";
import FoodMitraAdmin14 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin14.png";
import FoodMitraAdmin15 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin15.png";
import FoodMitraAdmin16 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin16.png";
import FoodMitraAdmin18 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin18.png";
import FoodMitraAdmin19 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin19.png";
import FoodMitraAdmin20 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin20.png";
import FoodMitraAdmin21 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin21.png";
import FoodMitraAdmin22 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin22.png";
import FoodMitraAdmin23 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin23.png";
import FoodMitraAdmin24 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin24.png";
import FoodMitraAdmin25 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin25.png";
import FoodMitraAdmin26 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin26.png";
import FoodMitraAdmin27 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin27.png";
import FoodMitraAdmin28 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin28.png";
import FoodMitraAdmin29 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin29.png";
import FoodMitraAdmin30 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin30.png";
import FoodMitraAdmin31 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin31.png";
import FoodMitraAdmin32 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin32.png";
import FoodMitraAdmin33 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin33.png";
import FoodMitraAdmin34 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin34.png";
import FoodMitraAdmin35 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin35.png";
import FoodMitraAdmin36 from "../assets/projectsImg/FoodMitraAdmin/FoodMitraAdmin36.png";

// ============================================================
// 🖼️ GALLERY — FoodMitra Vendor
// ============================================================
import FoodMitraVendor from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor.png";
import FoodMitraVendor1 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor1.png";
import FoodMitraVendor2 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor2.png";
import FoodMitraVendor3 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor3.png";
import FoodMitraVendor4 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor4.png";
import FoodMitraVendor5 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor5.png";
import FoodMitraVendor6 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor6.png";
import FoodMitraVendor7 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor7.png";
import FoodMitraVendor8 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor8.png";
import FoodMitraVendor9 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor9.png";
import FoodMitraVendor10 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor10.png";
import FoodMitraVendor11 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor11.png";
import FoodMitraVendor12 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor12.png";
import FoodMitraVendor13 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor13.png";
import FoodMitraVendor14 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor14.png";
import FoodMitraVendor15 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor15.png";
import FoodMitraVendor16 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor16.png";
import FoodMitraVendor17 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor17.png";
import FoodMitraVendor18 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor18.png";
import FoodMitraVendor19 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor19.png";
import FoodMitraVendor20 from "../assets/projectsImg/FoodMitraVendor/FoodMitraVendor20.png";

// ============================================================
// 🖼️ GALLERY — FoodMitra Customer Mobile App
// ============================================================
import FoodMitraApp1 from "../assets/AppImg/FoodMitra/FoodMitraApp1.jpg";
import FoodMitraApp2 from "../assets/AppImg/FoodMitra/FoodMitraApp2.jpg";
import FoodMitraApp3 from "../assets/AppImg/FoodMitra/FoodMitraApp3.jpg";
import FoodMitraApp4 from "../assets/AppImg/FoodMitra/FoodMitraApp4.jpg";
import FoodMitraApp5 from "../assets/AppImg/FoodMitra/FoodMitraApp5.jpg";
import FoodMitraApp6 from "../assets/AppImg/FoodMitra/FoodMitraApp6.jpg";
import FoodMitraApp7 from "../assets/AppImg/FoodMitra/FoodMitraApp7.jpg";
import FoodMitraApp8 from "../assets/AppImg/FoodMitra/FoodMitraApp8.jpg";
import FoodMitraApp9 from "../assets/AppImg/FoodMitra/FoodMitraApp9.jpg";
import FoodMitraApp10 from "../assets/AppImg/FoodMitra/FoodMitraApp10.jpg";
import FoodMitraApp11 from "../assets/AppImg/FoodMitra/FoodMitraApp11.jpg";
import FoodMitraApp12 from "../assets/AppImg/FoodMitra/FoodMitraApp12.jpg";
import FoodMitraApp13 from "../assets/AppImg/FoodMitra/FoodMitraApp13.jpg";
import FoodMitraApp14 from "../assets/AppImg/FoodMitra/FoodMitraApp14.jpg";
import FoodMitraApp15 from "../assets/AppImg/FoodMitra/FoodMitraApp15.jpg";
import FoodMitraApp16 from "../assets/AppImg/FoodMitra/FoodMitraApp16.jpg";
import FoodMitraApp17 from "../assets/AppImg/FoodMitra/FoodMitraApp17.jpg";
import FoodMitraApp18 from "../assets/AppImg/FoodMitra/FoodMitraApp18.jpg";
import FoodMitraApp19 from "../assets/AppImg/FoodMitra/FoodMitraApp19.jpg";
import FoodMitraApp20 from "../assets/AppImg/FoodMitra/FoodMitraApp20.jpg";
import FoodMitraApp21 from "../assets/AppImg/FoodMitra/FoodMitraApp21.jpg";
import FoodMitraApp22 from "../assets/AppImg/FoodMitra/FoodMitraApp22.jpg";
import FoodMitraApp23 from "../assets/AppImg/FoodMitra/FoodMitraApp23.jpg";
import FoodMitraApp24 from "../assets/AppImg/FoodMitra/FoodMitraApp24.jpg";
import FoodMitraApp25 from "../assets/AppImg/FoodMitra/FoodMitraApp25.jpg";
import FoodMitraApp26 from "../assets/AppImg/FoodMitra/FoodMitraApp26.jpg";
import FoodMitraApp27 from "../assets/AppImg/FoodMitra/FoodMitraApp27.jpg";
import FoodMitraApp28 from "../assets/AppImg/FoodMitra/FoodMitraApp28.jpg";
import FoodMitraApp29 from "../assets/AppImg/FoodMitra/FoodMitraApp29.jpg";
import FoodMitraApp30 from "../assets/AppImg/FoodMitra/FoodMitraApp30.jpg";
import FoodMitraApp31 from "../assets/AppImg/FoodMitra/FoodMitraApp31.jpg";
import FoodMitraApp32 from "../assets/AppImg/FoodMitra/FoodMitraApp32.jpg";
import FoodMitraApp33 from "../assets/AppImg/FoodMitra/FoodMitraApp33.jpg";
import FoodMitraApp34 from "../assets/AppImg/FoodMitra/FoodMitraApp34.jpg";
import FoodMitraApp35 from "../assets/AppImg/FoodMitra/FoodMitraApp35.jpg";
import FoodMitraApp36 from "../assets/AppImg/FoodMitra/FoodMitraApp36.jpg";

// ============================================================
// 🖼️ GALLERY — FoodMitra Delivery Partner App
// ============================================================
import FoodMitraDeliveryApp1 from "../assets/AppImg/FoodMitraDelivery/FoodMitraDeliveryApp1.jpg";
import FoodMitraDeliveryApp2 from "../assets/AppImg/FoodMitraDelivery/FoodMitraDeliveryApp2.jpg";
import FoodMitraDeliveryApp3 from "../assets/AppImg/FoodMitraDelivery/FoodMitraDeliveryApp3.jpg";
import FoodMitraDeliveryApp4 from "../assets/AppImg/FoodMitraDelivery/FoodMitraDeliveryApp4.jpg";
import FoodMitraDeliveryApp5 from "../assets/AppImg/FoodMitraDelivery/FoodMitraDeliveryApp5.jpg";
import FoodMitraDeliveryApp6 from "../assets/AppImg/FoodMitraDelivery/FoodMitraDeliveryApp6.jpg";
import FoodMitraDeliveryApp7 from "../assets/AppImg/FoodMitraDelivery/FoodMitraDeliveryApp7.jpg";
import FoodMitraDeliveryApp8 from "../assets/AppImg/FoodMitraDelivery/FoodMitraDeliveryApp8.jpg";
import FoodMitraDeliveryApp9 from "../assets/AppImg/FoodMitraDelivery/FoodMitraDeliveryApp9.jpg";
import FoodMitraDeliveryApp10 from "../assets/AppImg/FoodMitraDelivery/FoodMitraDeliveryApp10.jpg";
import FoodMitraDeliveryApp11 from "../assets/AppImg/FoodMitraDelivery/FoodMitraDeliveryApp11.jpg";
import FoodMitraDeliveryApp12 from "../assets/AppImg/FoodMitraDelivery/FoodMitraDeliveryApp12.jpg";
import FoodMitraDeliveryApp13 from "../assets/AppImg/FoodMitraDelivery/FoodMitraDeliveryApp13.jpg";
import FoodMitraDeliveryApp14 from "../assets/AppImg/FoodMitraDelivery/FoodMitraDeliveryApp14.jpg";
import FoodMitraDeliveryApp15 from "../assets/AppImg/FoodMitraDelivery/FoodMitraDeliveryApp15.jpg";
import FoodMitraDeliveryApp16 from "../assets/AppImg/FoodMitraDelivery/FoodMitraDeliveryApp16.jpg";
import FoodMitraDeliveryApp17 from "../assets/AppImg/FoodMitraDelivery/FoodMitraDeliveryApp17.jpg";

// ============================================================
// 🖼️ GALLERY — FoodMitra Tiffin House App
// ============================================================
import FoodMitraTiffinHouseApp1 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp1.jpg";
import FoodMitraTiffinHouseApp2 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp2.jpg";
import FoodMitraTiffinHouseApp3 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp3.jpg";
import FoodMitraTiffinHouseApp4 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp4.jpg";
import FoodMitraTiffinHouseApp5 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp5.jpg";
import FoodMitraTiffinHouseApp6 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp6.jpg";
import FoodMitraTiffinHouseApp7 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp7.jpg";
import FoodMitraTiffinHouseApp8 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp8.jpg";
import FoodMitraTiffinHouseApp9 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp9.jpg";
import FoodMitraTiffinHouseApp10 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp10.jpg";
import FoodMitraTiffinHouseApp11 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp11.jpg";
import FoodMitraTiffinHouseApp12 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp12.jpg";
import FoodMitraTiffinHouseApp13 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp13.jpg";
import FoodMitraTiffinHouseApp14 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp14.jpg";
import FoodMitraTiffinHouseApp15 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp15.jpg";
import FoodMitraTiffinHouseApp16 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp16.jpg";
import FoodMitraTiffinHouseApp17 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp17.jpg";
import FoodMitraTiffinHouseApp18 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp18.jpg";
import FoodMitraTiffinHouseApp19 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp19.jpg";
import FoodMitraTiffinHouseApp20 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp20.jpg";
import FoodMitraTiffinHouseApp21 from "../assets/AppImg/FoodMitraHouseTiffin/FoodMitraTiffinHouseApp21.jpg";

// ============================================================
// 🖼️ GALLERY — ParkEasy User App
// ============================================================
import parkEasyUser1 from "../assets/AppImg/parkEasyUser/parkEasyUserApp1.jpg";
import parkEasyUser2 from "../assets/AppImg/parkEasyUser/parkEasyUserApp2.jpg";
import parkEasyUser3 from "../assets/AppImg/parkEasyUser/parkEasyUserApp3.jpg";
import parkEasyUser4 from "../assets/AppImg/parkEasyUser/parkEasyUserApp4.jpg";
import parkEasyUser5 from "../assets/AppImg/parkEasyUser/parkEasyUserApp5.jpg";
import parkEasyUser6 from "../assets/AppImg/parkEasyUser/parkEasyUserApp6.jpg";
import parkEasyUser7 from "../assets/AppImg/parkEasyUser/parkEasyUserApp7.jpg";
import parkEasyUser8 from "../assets/AppImg/parkEasyUser/parkEasyUserApp8.jpg";
import parkEasyUser9 from "../assets/AppImg/parkEasyUser/parkEasyUserApp9.jpg";
import parkEasyUser10 from "../assets/AppImg/parkEasyUser/parkEasyUserApp10.jpg";
import parkEasyUser11 from "../assets/AppImg/parkEasyUser/parkEasyUserApp11.jpg";
import parkEasyUser12 from "../assets/AppImg/parkEasyUser/parkEasyUserApp12.jpg";
import parkEasyUser13 from "../assets/AppImg/parkEasyUser/parkEasyUserApp13.jpg";
import parkEasyUser14 from "../assets/AppImg/parkEasyUser/parkEasyUserApp14.jpg";

// ============================================================
// 🖼️ GALLERY — ParkEasy Admin
// ============================================================
import parkEasyAdmin1 from "../assets/AppImg/ParkEasyAdmin/parkEasyAdmin1.jpg";
import parkEasyAdmin2 from "../assets/AppImg/ParkEasyAdmin/parkEasyAdmin2.jpg";
import parkEasyAdmin3 from "../assets/AppImg/ParkEasyAdmin/parkEasyAdmin3.jpg";
import parkEasyAdmin4 from "../assets/AppImg/ParkEasyAdmin/parkEasyAdmin4.jpg";
import parkEasyAdmin5 from "../assets/AppImg/ParkEasyAdmin/parkEasyAdmin5.jpg";
import parkEasyAdmin6 from "../assets/AppImg/ParkEasyAdmin/parkEasyAdmin6.jpg";
import parkEasyAdmin7 from "../assets/AppImg/ParkEasyAdmin/parkEasyAdmin7.jpg";
import parkEasyAdmin8 from "../assets/AppImg/ParkEasyAdmin/parkEasyAdmin8.jpg";
import parkEasyAdmin9 from "../assets/AppImg/ParkEasyAdmin/parkEasyAdmin9.jpg";
import parkEasyAdmin10 from "../assets/AppImg/ParkEasyAdmin/parkEasyAdmin10.jpg";
import parkEasyAdmin11 from "../assets/AppImg/ParkEasyAdmin/parkEasyAdmin11.jpg";
import parkEasyAdmin12 from "../assets/AppImg/ParkEasyAdmin/parkEasyAdmin12.jpg";
import parkEasyAdmin13 from "../assets/AppImg/ParkEasyAdmin/parkEasyAdmin13.jpg";

// ============================================================
// 📦 WEB PROJECTS DATA
// ============================================================
export const webProjects = [
  {
    id: 1,
    title: "FoodMitra",
    category: "Full-Stack Food Delivery Ecosystem",
    projectType: "fullstack",
    industry: "Food Delivery",
    description:
      "A full-stack food delivery ecosystem connecting customers, vendors, delivery partners, and home-based tiffin providers.",
    fullDescription: `FoodMitra is a full-stack food delivery ecosystem consisting of three applications: FoodMitra Customer App, FoodMitra Delivery Partner App, and FoodMitra House Tiffin. The platform connects customers, food vendors, delivery partners, and home-based tiffin providers through a unified system.

The Customer App allows users to browse food, manage carts, place orders, make online payments, and track orders. The Delivery Partner App enables delivery partners to manage assigned orders and update delivery status. FoodMitra House Tiffin supports home-based food providers and tiffin services, helping customers discover and order locally prepared meals.

The platform includes role-based authentication using JWT and HTTP Cookies, vendor onboarding and approval workflows, real-time order and delivery updates using Socket.IO, Razorpay payment integration, Firebase services, Google APIs for location and map-related functionality, and REST APIs powered by Node.js, Express.js, and MongoDB.`,
    image: foodmitra,
    gallery: [
      foodmitra,
      FoodMitra1,
      FoodMitra2,
      FoodMitra3,
      FoodMitra4,
      FoodMitra5,
      FoodMitra6,
      FoodMitra7,
      FoodMitra8,
      FoodMitra9,
      FoodMitra10,
      FoodMitra11,
      FoodMitra12,
      FoodMitra13,
      FoodMitra14,
      FoodMitra15,
      FoodMitra16,
      FoodMitra17,
      FoodMitra18,
      FoodMitra19,
      FoodMitraAdmin1,
      FoodMitraAdmin2,
      FoodMitraAdmin3,
      FoodMitraAdmin4,
      FoodMitraAdmin5,
      FoodMitraAdmin6,
      FoodMitraAdmin7,
      FoodMitraAdmin8,
      FoodMitraAdmin9,
      FoodMitraAdmin10,
      FoodMitraAdmin11,
      FoodMitraAdmin12,
      FoodMitraAdmin13,
      FoodMitraAdmin14,
      FoodMitraAdmin15,
      FoodMitraAdmin16,
      FoodMitraAdmin18,
      FoodMitraAdmin19,
      FoodMitraAdmin20,
      FoodMitraAdmin21,
      FoodMitraAdmin22,
      FoodMitraAdmin23,
      FoodMitraAdmin24,
      FoodMitraAdmin25,
      FoodMitraAdmin26,
      FoodMitraAdmin27,
      FoodMitraAdmin28,
      FoodMitraAdmin29,
      FoodMitraAdmin30,
      FoodMitraAdmin31,
      FoodMitraAdmin32,
      FoodMitraAdmin33,
      FoodMitraAdmin34,
      FoodMitraAdmin35,
      FoodMitraAdmin36,
      FoodMitraVendor,
      FoodMitraVendor1,
      FoodMitraVendor2,
      FoodMitraVendor3,
      FoodMitraVendor4,
      FoodMitraVendor5,
      FoodMitraVendor6,
      FoodMitraVendor7,
      FoodMitraVendor8,
      FoodMitraVendor9,
      FoodMitraVendor10,
      FoodMitraVendor11,
      FoodMitraVendor12,
      FoodMitraVendor13,
      FoodMitraVendor14,
      FoodMitraVendor15,
      FoodMitraVendor16,
      FoodMitraVendor17,
      FoodMitraVendor18,
      FoodMitraVendor19,
      FoodMitraVendor20,
    ],
    technologies: [
      "React",
      "React Native",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Socket.io",
      "JWT",
      "Firebase",
      "Google APIs",
      "Razorpay",
      "Tailwind CSS",
      "Custom CSS",
    ],
    complexity: "Advanced",
    duration: "3+ months",
    rating: 4,
    liveUrl: "https://myfoodmitra.vercel.app/",
    githubUrl:
      "https://github.com/Ratnakar-Singh-parihar-123/Food-Delivery-Platform-",
    features: [
      "Customer food ordering",
      "Delivery partner application",
      "House tiffin platform",
      "Role-based authentication",
      "Real-time order tracking",
      "Vendor approval workflow",
      "Online payments",
      "Location & map integration",
      "Admin management",
    ],
    metrics: [
      { icon: "Users", value: "1000+", label: "Target Users" },
      { icon: "Layers", value: "3", label: "Applications" },
      { icon: "Zap", value: "Real-time", label: "Order Updates" },
    ],
    status: "Live",
    featured: true,
  },
  {
    id: 2,
    title: "Vehicle Service Booking Platform",
    category: "Full-Stack Web Application",
    projectType: "fullstack",
    industry: "Automotive",
    description:
      "A real-time vehicle service booking system connecting customers with local service centers.",
    fullDescription: `Developed a real-world MERN stack platform enabling customers to book, track, and manage vehicle services online. Service centers can view customer requests, update service status, and handle digital payments. Includes live chat, order tracking, and dynamic dashboards.`,
    image: vsbp,
    gallery: [
      vsbp,
      VSBP1,
      VSBP2,
      VSBP3,
      VSBP4,
      VSBP5,
      VSBP6,
      VSBP7,
      VSBP8,
      VSBP9,
      VSBP10,
      VSBP11,
      VSBP12,
      VSBP13,
      VSBP14,
      VSBP15,
      VSBP16,
      VSBP17,
      VSBP18,
      VSBP19,
      VSBP20,
      VSBP21,
      VSBP22,
      VSBP23,
      VSBP24,
      VSBP25,
    ],
    technologies: [
      "React",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Socket.io",
      "Tailwind CSS",
    ],
    complexity: "Advanced",
    duration: "3 months",
    rating: 5,
    liveUrl: "https://vehicle-service-booking-platform.onrender.com",
    githubUrl:
      "https://github.com/Ratnakar-Singh-parihar-123/Vehicle-Service-Booking-Platform",
    features: [
      "Role-based login",
      "Real-time chat",
      "Live service tracking",
      "Payment management",
      "Analytics dashboards",
    ],
    metrics: [
      { icon: "Users", value: "1000+", label: "Active Users" },
      { icon: "Wrench", value: "500+", label: "Services Completed" },
      { icon: "Clock", value: "Real-time", label: "Service Tracking" },
    ],
    status: "Live",
    featured: true,
  },
  {
    id: 3,
    title: "Jeevandaan – Blood & Organ Donation",
    category: "Full-Stack Application",
    projectType: "fullstack",
    industry: "Healthcare",
    description:
      "Real-time healthcare platform connecting blood and organ donors with recipients.",
    fullDescription: `Jeevandaan is an advanced MERN stack healthcare platform designed to reduce emergency response time by intelligently connecting donors, recipients, and hospitals in real time.`,
    image: bodp,
    gallery: [bodp6, bodp, bodp1, bodp2, bodp3, bodp4, bodp5],
    technologies: [
      "React",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Socket.io",
      "Twilio",
      "Tailwind CSS",
      "Mapbox",
    ],
    complexity: "Advanced",
    duration: "4 months",
    rating: 5,
    liveUrl: "https://jeevandaancare.vercel.app/",
    githubUrl:
      "https://github.com/Ratnakar-Singh-parihar-123/Blood-Organ-Donations-",
    features: [
      "Real-time donor matching",
      "OTP authentication",
      "Emergency alerts",
      "Hospital dashboard",
      "Location search",
    ],
    metrics: [
      { icon: "HeartPulse", value: "250+", label: "Successful Donations" },
      { icon: "Hospital", value: "60+", label: "Partner Hospitals" },
      { icon: "Users", value: "1800+", label: "Verified Donors" },
    ],
    status: "Production Ready",
    featured: true,
  },
  {
    id: 4,
    title: "YammiVerse",
    category: "Web Application",
    projectType: "react",
    industry: "Food & Recipes",
    description:
      "A community-driven recipe platform for sharing, exploring, and saving food recipes.",
    fullDescription: `Built a feature-rich MERN stack application that allows users to upload, save, and discover recipes. Includes user authentication, image uploads, and responsive design.`,
    image: yammiverse,
    gallery: [yammiverse],
    technologies: ["React", "Node.js", "Express.js", "MongoDB", "Tailwind CSS"],
    complexity: "Intermediate",
    duration: "3 months",
    rating: 4,
    liveUrl: "https://yammiverse.onrender.com",
    githubUrl: "https://github.com/Ratnakar-Singh-parihar-123/YammiVerse",
    features: [
      "User authentication",
      "Recipe creation",
      "Favorites",
      "Responsive UI",
      "Search filtering",
    ],
    metrics: [
      { icon: "Utensils", value: "10K+", label: "Recipes Uploaded" },
      { icon: "Users", value: "3K+", label: "Active Users" },
      { icon: "Heart", value: "8K+", label: "Recipes Liked" },
    ],
    status: "Live",
    featured: true,
  },
  {
    id: 5,
    title: "TextUtils",
    category: "React Utility App",
    projectType: "react",
    industry: "Productivity",
    description:
      "A lightweight React-based text utility app offering real-time text transformations.",
    fullDescription: `Developed a fast, interactive web app using React to manipulate and analyze text. Supports uppercase/lowercase conversion, word/character counting, and reading time estimation.`,
    image: textutils,
    gallery: [textutils, textutils1, textutils2, textutilshome],
    technologies: ["React", "Tailwind CSS"],
    complexity: "Beginner",
    duration: "2 weeks",
    rating: 4,
    liveUrl: "https://ratnakar-singh-parihar-123.github.io/TextUtils/",
    githubUrl: "https://github.com/Ratnakar-Singh-parihar-123/TextUtils",
    features: [
      "Text transformation",
      "Word counter",
      "Reading time",
      "Dark mode",
    ],
    metrics: [
      { icon: "Users", value: "", label: "Daily Users" },
      { icon: "Star", value: "4.0", label: "Rating" },
    ],
    status: "Live",
    featured: false,
  },
  {
    id: 6,
    title: "Personal Portfolio Website",
    category: "Web Portfolio",
    projectType: "react",
    industry: "Personal Branding",
    description:
      "A modern and interactive developer portfolio designed to showcase professional projects, technical skills, achievements, experience, and learning journey.",
    fullDescription: `Designed and developed a modern, responsive personal portfolio using React and Tailwind CSS. The portfolio focuses on creating a premium user experience with smooth animations, interactive project showcases, technical skill sections, achievements, experience, education, and a dedicated contact experience. It is optimized for desktop, tablet, and mobile devices with a clean and scalable component-based architecture.`,
    image: portfolio2,
    gallery: [
      portfolio1,
      portfolio2,
      portfolio3,
      portfolio4,
      portfolio5,
      portfolio6,
      portfolio7,
      portfolio8,
      portfolio9,
      portfolio10,
      portfolio11,
      portfolio12,
      portfolio13,
      portfolio14,
      portfolio15,
      portfolio16,
      portfolio17,
      portfolio18,
      portfolio19,
      portfolio20,
      portfolio21,
      portfolio22,
      portfolio23,
      portfolio24,
      portfolio25,
      portfolio26,
      portfolio27,
      portfolio28,
      portfolio29,
      portfolio30,
      portfolio31,
      portfolio32,
    ],
    technologies: [
      "React",
      "Tailwind CSS",
      "Framer Motion",
      "JavaScript",
      "React Router",
      "Lucide React",
    ],
    complexity: "Intermediate",
    duration: "2 months",
    rating: 5,
    liveUrl: "https://my-portfolio-78gt.vercel.app/",
    githubUrl: "https://github.com/Ratnakar-Singh-parihar-123/MyPortfolio",
    features: [
      "Responsive design",
      "Dark and light mode",
      "Smooth page transitions",
      "Interactive project showcase",
      "Animated components",
      "Project search functionality",
      "Project case study view",
      "Book My Call integration",
      "Skills and technology showcase",
      "Experience and education timeline",
      "Achievements section",
      "Mobile-friendly navigation",
      "Resume download",
      "Contact section",
    ],
    metrics: [
      { icon: "Users", value: "100+", label: "Visitors" },
      { icon: "Star", value: "5.0", label: "Rating" },
    ],
    status: "Live",
    featured: true,
  },
  {
    id: 7,
    title: "SpiceCraft Traders",
    category: "E-commerce Website",
    projectType: "htmlcss",
    industry: "Food & Spices",
    description:
      "A clean, responsive HTML-CSS website for a fictional spice brand.",
    fullDescription: `SpiceCraft Traders is a visually appealing and fast-loading spice brand website built using pure HTML and CSS.`,
    image: SpiceCraft,
    gallery: [
      SpiceCraft,
      SpiceCraft1,
      SpiceCraft2,
      SpiceCraft3,
      SpiceCraft4,
      SpiceCraft5,
      SpiceCraft6,
    ],
    technologies: ["HTML", "CSS"],
    complexity: "Beginner",
    duration: "1 week",
    rating: 3,
    liveUrl: "https://spice-craft-traders.vercel.app/",
    githubUrl:
      "https://github.com/Ratnakar-Singh-parihar-123/SpiceCraft-Traders",
    features: [
      "Hero banner",
      "Product section",
      "Hover animations",
      "Contact form",
      "Responsive",
    ],
    metrics: [{ icon: "Eye", value: "1K+", label: "Views" }],
    status: "Live",
    featured: false,
  },
  {
    id: 8,
    title: "FlavorBite Restaurant",
    category: "Landing Page",
    projectType: "htmlcss",
    industry: "Food & Restaurant",
    description:
      "A modern, responsive restaurant landing page built with pure HTML and CSS.",
    fullDescription: `FlavorBite Restaurant is a fully responsive restaurant landing page with sections like hero banner, about us, menu highlights, services, and contact form.`,
    image: RestaurantMain,
    gallery: [
      RestaurantMain,
      RestaurantMenu,
      RestaurantAbout,
      RestaurantChef,
      RestaurantGallery,
      RestaurantContact,
      UpcomingEvents,
      RestaurantFooter,
    ],
    technologies: ["HTML", "CSS"],
    complexity: "Beginner",
    duration: "5 days",
    rating: 3,
    liveUrl: "https://restaurant-landing-page-one.vercel.app/",
    githubUrl:
      "https://github.com/Ratnakar-Singh-parihar-123/Restaurant-Landing-Page",
    features: [
      "Hero section",
      "Menu highlights",
      "Gallery",
      "Contact form",
      "Responsive",
    ],
    metrics: [],
    status: "Live",
    featured: false,
  },
  {
    id: 9,
    title: "EduMentor Coaching",
    category: "Landing Page",
    projectType: "htmlcss",
    industry: "Education & Coaching",
    description:
      "A clean and responsive coaching-course landing page built with pure HTML and CSS.",
    fullDescription: `EduMentor Coaching is a fully responsive coaching landing page with sections like hero banner, courses offered, features, testimonials, and contact form.`,
    image: CoachingMain,
    gallery: [
      CoachingMain,
      CoachingHomeSecond,
      CoachingCourses,
      CoachingFeatures,
      CoachingTestimonials,
    ],
    technologies: ["HTML", "CSS"],
    complexity: "Beginner",
    duration: "5 days",
    rating: 3,
    liveUrl: "https://coaching-course-website.vercel.app/",
    githubUrl:
      "https://github.com/Ratnakar-Singh-parihar-123/Coaching-Course-Website",
    features: [
      "Hero section",
      "Courses section",
      "Testimonials",
      "Contact form",
      "Responsive",
    ],
    metrics: [],
    status: "Live",
    featured: false,
  },
  {
    id: 10,
    title: "Tiffin Delivery Web App",
    category: "Food Delivery",
    projectType: "react",
    industry: "Food & Services",
    description:
      "A modern tiffin delivery web application with user authentication.",
    fullDescription: `Built using React and Tailwind CSS, this tiffin delivery platform allows users to register, log in, and explore daily meal plans.`,
    image: tiffinDelivery,
    gallery: [
      tiffinDelivery,
      TiffinDeliveryUser,
      TiffinDeliveryCreateAcc,
      TiffinDeliveryAdmindashboard,
      TiffinDelivery3,
      TiffinDelivery4,
      TiffinDelivery5,
      TiffinDelivery6,
      TiffinDelivery7,
    ],
    technologies: ["React", "Tailwind CSS", "React Router"],
    complexity: "Intermediate",
    duration: "1.5 months",
    rating: 4,
    liveUrl: "https://tiffin-delievery.vercel.app/",
    githubUrl: "https://github.com/Ratnakar-Singh-parihar-123/tiffin-delivery",
    features: [
      "User login/signup",
      "Form validation",
      "Protected routes",
      "Responsive UI",
    ],
    metrics: [],
    status: "Live",
    featured: true,
  },
  {
    id: 11,
    title: "ScaleGate",
    category: "Java High-Performance Load Balancer",
    projectType: "system-design",
    industry: "Distributed Systems",
    description:
      "A Java-based high-performance load balancer project focused on distributed systems, routing algorithms, concurrency, fault tolerance, and scalable system design.",
    fullDescription: `ScaleGate is an ongoing Java-based high-performance load balancer project built as a practical exploration of distributed systems, data structures, concurrency, networking, and system design.

The project is designed to understand how a load balancer can distribute incoming requests across multiple backend servers while handling server health, failures, retries, rate limiting, and traffic distribution.

The current implementation focuses on core load balancing concepts including Round Robin, Least Connections, Weighted Routing, and Consistent Hashing. Consistent Hashing uses a TreeMap-based hash ring and ceilingEntry() to efficiently locate the next available server.

ScaleGate also explores fault-tolerance patterns such as health checks, retry and failover mechanisms, rate limiting, and circuit breaker behavior.

The project is currently under active development. The implementation is not yet complete and does not currently have a public live deployment or published GitHub repository. New system design concepts, performance improvements, testing, and production-oriented features are being added incrementally.`,
    image: Scalegate,
    gallery: [Scalegate],
    technologies: [
      "Java",
      "Data Structures",
      "System Design",
      "Multithreading",
      "Networking",
      "ConcurrentHashMap",
      "TreeMap",
      "Consistent Hashing",
      "Docker",
    ],
    complexity: "Advanced",
    duration: "Ongoing",
    rating: 0,
    liveUrl: null,
    githubUrl: null,
    features: [
      "Round Robin load balancing",
      "Least Connections routing",
      "Weighted routing",
      "Consistent Hashing",
      "TreeMap-based hash ring",
      "TreeMap ceilingEntry() server lookup",
      "Server health checks",
      "Retry mechanism",
      "Request failover",
      "Rate limiting",
      "Circuit breaker",
      "Concurrent server registry",
      "Traffic distribution",
      "Performance and load testing",
      "Metrics and request monitoring",
    ],
    metrics: [],
    status: "In Development",
    developmentNote:
      "ScaleGate is currently under active development. Core load balancing and system design concepts are being implemented and tested. Public GitHub and live deployment will be added after the project reaches a stable milestone.",
    featured: true,
  },
];

// ============================================================
// 📱 MOBILE APPS DATA
// ============================================================
export const mobileAppsData = [
  {
    id: "app1",
    title: "FoodMitra",
    projectType: "mobile",
    description:
      "FoodMitra is a complete food delivery ecosystem that connects customers with nearby food vendors and Tiffin Houses. The platform supports food discovery, menu browsing, cart management, order placement, online payments, real-time order updates, and delivery tracking through dedicated mobile applications.",
    fullDescription: `FoodMitra is a full-stack food delivery ecosystem built to simplify the complete food ordering and delivery experience. The platform connects customers with nearby food vendors and home-based Tiffin Houses through a unified mobile application.

Customers can discover nearby food options, browse menus, view food details, add items to their cart, manage quantities, place orders, and complete secure online payments. The application also provides order status updates and delivery tracking to create a smooth end-to-end ordering experience.

The ecosystem is designed with multiple user roles including Customers, Vendors, Delivery Partners, Tiffin Houses, and Admin. Vendors and Tiffin Houses can manage their food items and incoming orders, while delivery partners can handle assigned deliveries and update delivery status.

FoodMitra also integrates real-time communication using Socket.io for order and delivery updates. Authentication and user management are handled using JWT and Firebase services, while Razorpay is integrated for online payment processing.

The backend is deployed on Render and the mobile application is available as an APK for Android testing. Since the backend is hosted on Render's free/server-sleep infrastructure, the first API request after a period of inactivity may take a little longer while the server starts. Once the backend is active, subsequent requests work normally.

Demo Login:
Mobile Number: 9399741051
OTP: 123456

The demo credentials are provided only for portfolio/project demonstration purposes.`,
    image: FoodMitraApp,
    gallery: [
      FoodMitraApp,
      FoodMitraApp1,
      FoodMitraApp2,
      FoodMitraApp3,
      FoodMitraApp4,
      FoodMitraApp5,
      FoodMitraApp6,
      FoodMitraApp7,
      FoodMitraApp8,
      FoodMitraApp9,
      FoodMitraApp10,
      FoodMitraApp11,
      FoodMitraApp12,
      FoodMitraApp13,
      FoodMitraApp14,
      FoodMitraApp15,
      FoodMitraApp16,
      FoodMitraApp17,
      FoodMitraApp18,
      FoodMitraApp19,
      FoodMitraApp20,
      FoodMitraApp21,
      FoodMitraApp22,
      FoodMitraApp23,
      FoodMitraApp24,
      FoodMitraApp25,
      FoodMitraApp26,
      FoodMitraApp27,
      FoodMitraApp28,
      FoodMitraApp29,
      FoodMitraApp30,
      FoodMitraApp31,
      FoodMitraApp32,
      FoodMitraApp33,
      FoodMitraApp34,
      FoodMitraApp35,
      FoodMitraApp36,
    ],
    technologies: [
      "React Native",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Socket.io",
      "Razorpay",
      "Firebase",
      "JWT",
    ],
    platforms: ["Android"],
    features: [
      "Customer food discovery",
      "Nearby food vendors and Tiffin Houses",
      "Menu and food item browsing",
      "Cart and quantity management",
      "Order placement and management",
      "Online payment integration",
      "Real-time order updates",
      "Delivery partner workflow",
      "Order tracking",
      "Vendor and Tiffin House management",
      "Firebase-based authentication",
      "JWT-based authorization",
      "Admin-controlled vendor approval",
    ],
    complexity: "Advanced",
    duration: "2 months",
    teamSize: "1",
    impact:
      "Provides an end-to-end food ordering ecosystem that connects customers, food vendors, Tiffin Houses, delivery partners, and administrators through a unified platform.",
    liveUrl: "https://myfoodmitra.vercel.app/",
    githubUrl:
      "https://github.com/Ratnakar-Singh-parihar-123/Food-Delivery-Platform-",
    apkUrl: "../../public/foodmitra-customer.apk",
    backendUrl: "https://food-delivery-platform-ypx6.onrender.com",
    demoCredentials: { mobile: "9399741051", otp: "123456" },
    deploymentNote:
      "The backend is deployed on Render. Due to server sleep/cold-start behavior, the first request may take a little longer after inactivity. Please wait a few seconds and retry if required.",
    status: "In Development",
    featured: true,
    iconColor: "from-orange-500 to-red-500",
    iconName: "Utensils",
  },
  {
    id: "app2",
    title: "FoodMitra Delivery Partner",
    projectType: "mobile",
    description:
      "FoodMitra Delivery Partner is a dedicated delivery management application that enables delivery partners to receive nearby orders, accept delivery requests, manage pickups, navigate to customer locations, and complete deliveries with real-time order updates.",
    fullDescription: `FoodMitra Delivery Partner is a dedicated mobile application developed as part of the FoodMitra food delivery ecosystem. The application is designed specifically for delivery partners and manages the complete delivery workflow from receiving a delivery request to successfully completing the order.

Delivery partners can securely log in using mobile number authentication with dynamically generated OTPs. After authentication, they can view available delivery requests, check order details, review pickup and customer locations, and accept suitable delivery requests.

Once an order is accepted, the delivery partner can manage the complete pickup-to-delivery process. The application provides relevant order information, pickup details, customer information, and delivery location to help partners complete deliveries efficiently.

Real-time communication is implemented using Socket.io so that important order and delivery status changes can be synchronized between the customer, vendor/Tiffin House, backend, and delivery partner applications.

The application also integrates location and mapping functionality to assist delivery partners in navigating between pickup and customer locations. The backend is built with Node.js and Express.js and uses MongoDB for data management.

Unlike the FoodMitra Customer App, this application does not use Firebase. Mobile authentication and OTP generation are handled through the application's backend OTP workflow.

Demo Note:
For portfolio demonstration, a valid mobile number can be used to test the OTP-based login flow. The OTP is dynamically generated by the application's authentication system, so there is no fixed demo OTP.

Backend Note:
The backend is deployed on Render. Because the server may go into an inactive state, the first API request after a period of inactivity can take a little longer while the backend starts. Once the server is active, subsequent requests should respond normally.`,
    image: FoodMitraDeliveryApp,
    gallery: [
      FoodMitraDeliveryApp1,
      FoodMitraDeliveryApp2,
      FoodMitraDeliveryApp3,
      FoodMitraDeliveryApp4,
      FoodMitraDeliveryApp5,
      FoodMitraDeliveryApp6,
      FoodMitraDeliveryApp7,
      FoodMitraDeliveryApp8,
      FoodMitraDeliveryApp9,
      FoodMitraDeliveryApp10,
      FoodMitraDeliveryApp11,
      FoodMitraDeliveryApp12,
      FoodMitraDeliveryApp13,
      FoodMitraDeliveryApp14,
      FoodMitraDeliveryApp15,
      FoodMitraDeliveryApp16,
      FoodMitraDeliveryApp17,
    ],
    technologies: [
      "React Native",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Socket.io",
      "JWT",
      "Google Maps",
    ],
    features: [
      "Mobile number authentication",
      "Dynamic OTP generation",
      "Delivery partner onboarding",
      "Nearby delivery requests",
      "Order details and pickup information",
      "Accept and manage delivery requests",
      "Pickup-to-delivery workflow",
      "Customer location tracking",
      "Google Maps integration",
      "Real-time order updates",
      "Socket.io-based communication",
      "Delivery status management",
      "Backend API integration",
    ],
    platforms: ["Android"],
    complexity: "Advanced",
    duration: "2 months",
    teamSize: "1",
    impact:
      "Streamlines the complete delivery workflow by connecting delivery partners with vendors, Tiffin Houses, and customers through real-time order management and location-based delivery coordination.",
    liveUrl: "https://myfoodmitra.vercel.app",
    githubUrl:
      "https://github.com/Ratnakar-Singh-parihar-123/Food-Delivery-Platform-",
    apkUrl: "../../public/foodmitra-delivery.apk",
    backendUrl: "https://food-delivery-platform-ypx6.onrender.com",
    demoCredentials: {
      type: "Dynamic OTP",
      mobile:
        "Use a valid/demo mobile number supported by the OTP authentication flow",
      otp: "Generated dynamically",
    },
    deploymentNote:
      "Backend deployed on Render. The first API request may take a few seconds after inactivity because of server cold-start behavior.",
    status: "In Development",
    featured: true,
    iconColor: "from-blue-500 to-cyan-500",
    iconName: "Bike",
  },
  {
    id: "app3",
    title: "FoodMitra Tiffin House",
    projectType: "mobile",
    description:
      "FoodMitra Tiffin House is a dedicated vendor-side mobile application that enables Tiffin House owners and food vendors to manage menus, receive customer orders, update food preparation status, and coordinate deliveries within the FoodMitra ecosystem.",
    fullDescription: `FoodMitra Tiffin House is a dedicated mobile application being developed for Tiffin House owners and food vendors as part of the FoodMitra food delivery ecosystem.

The application is designed to provide Tiffin Houses with a simple and centralized workflow for managing their daily food business. Vendors can manage their food menu, add and update food items, control item availability, receive incoming customer orders, and monitor the progress of each order.

The application is also designed to support the complete order preparation workflow. Tiffin House owners can review new orders, accept orders, update preparation status, and keep customers and delivery partners informed about the current order state.

Real-time order communication is implemented using Socket.io, allowing important order status changes to be synchronized across the FoodMitra ecosystem.

The application uses React Native for mobile development and is connected to a Node.js and Express.js backend with MongoDB for data management. Firebase services are used where required within the vendor-side application.

This project is currently under active development. The Android APK is not available yet.

APK Status: Coming Soon
Project Status: In Development`,
    image: FoodMitraTiffinHouseApp,
    gallery: [
      FoodMitraTiffinHouseApp,
      FoodMitraTiffinHouseApp1,
      FoodMitraTiffinHouseApp2,
      FoodMitraTiffinHouseApp3,
      FoodMitraTiffinHouseApp4,
      FoodMitraTiffinHouseApp5,
      FoodMitraTiffinHouseApp6,
      FoodMitraTiffinHouseApp7,
      FoodMitraTiffinHouseApp8,
      FoodMitraTiffinHouseApp9,
      FoodMitraTiffinHouseApp10,
      FoodMitraTiffinHouseApp11,
      FoodMitraTiffinHouseApp12,
      FoodMitraTiffinHouseApp13,
      FoodMitraTiffinHouseApp14,
      FoodMitraTiffinHouseApp15,
      FoodMitraTiffinHouseApp16,
      FoodMitraTiffinHouseApp17,
      FoodMitraTiffinHouseApp18,
      FoodMitraTiffinHouseApp19,
      FoodMitraTiffinHouseApp20,
      FoodMitraTiffinHouseApp21,
    ],
    technologies: [
      "React Native",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Socket.io",
      "Firebase",
      "JWT",
    ],
    features: [
      "Tiffin House vendor management",
      "Food menu management",
      "Add and update food items",
      "Food availability management",
      "Incoming customer orders",
      "Order acceptance and management",
      "Order preparation status",
      "Real-time order updates",
      "Delivery partner coordination",
      "Customer order synchronization",
      "Vendor-side order workflow",
      "Backend API integration",
    ],
    platforms: ["Android"],
    complexity: "Advanced",
    duration: "2 months+",
    teamSize: "1",
    impact:
      "Provides Tiffin Houses with a dedicated digital workflow for managing menus, customer orders, food preparation, and delivery coordination within the FoodMitra ecosystem.",
    liveUrl: "https://myfoodmitra.vercel.app/",
    githubUrl:
      "https://github.com/Ratnakar-Singh-parihar-123/Food-Delivery-Platform-",
    apkUrl: null,
    apkStatus: "Coming Soon",
    backendUrl: "https://food-delivery-platform-ypx6.onrender.com",
    status: "In Development",
    developmentNote:
      "This project is currently under active development. Core vendor workflows are being implemented and tested, while additional features and improvements are still in progress.",
    deploymentNote:
      "The backend is deployed on Render. The first API request may take a few seconds after inactivity because of server cold-start behavior.",
    featured: true,
    iconColor: "from-green-500 to-emerald-600",
    iconName: "Store",
  },
  {
    id: "app4",
    title: "ParkEasy",
    projectType: "mobile",
    description:
      "ParkEasy is a smart parking management application that helps users discover nearby parking spaces, check slot availability, book parking slots, and manage parking through a convenient mobile experience.",
    fullDescription: `ParkEasy is a smart parking management application designed to simplify the process of finding and booking parking spaces in urban areas.

Users can discover nearby parking locations, view available parking slots, check parking capacity, and book a suitable slot directly through the mobile application.

ParkEasy also includes a dedicated parking management workflow for administrators and parking owners. Through the admin interface, parking operators can manage parking locations, configure parking capacity, monitor available and occupied slots, and manage the overall parking operation.

The mobile application is built using React Native and communicates with a Node.js and Express.js backend. MongoDB is used for data storage, while payment functionality is integrated into the booking workflow.

The Android APK is available for demonstration and testing. The project is currently marked as Planned in the portfolio while additional improvements and refinements are being considered.`,
    image: parkEasyFront,
    gallery: [
      parkingapp,
      parkEasyUser1,
      parkEasyUser2,
      parkEasyUser3,
      parkEasyUser4,
      parkEasyUser5,
      parkEasyUser6,
      parkEasyUser7,
      parkEasyUser8,
      parkEasyUser9,
      parkEasyUser10,
      parkEasyUser11,
      parkEasyUser12,
      parkEasyUser13,
      parkEasyUser14,
      parkEasyAdmin1,
      parkEasyAdmin2,
      parkEasyAdmin3,
      parkEasyAdmin4,
      parkEasyAdmin5,
      parkEasyAdmin6,
      parkEasyAdmin7,
      parkEasyAdmin8,
      parkEasyAdmin9,
      parkEasyAdmin10,
      parkEasyAdmin11,
      parkEasyAdmin12,
      parkEasyAdmin13,
    ],
    technologies: ["React Native", "Node.js", "Express.js", "MongoDB", "CSS"],
    features: [
      "Nearby parking search",
      "Parking location discovery",
      "Real-time slot availability",
      "Parking capacity management",
      "Parking slot booking",
      "Booking management",
      "Secure payment integration",
      "Admin parking management",
      "Available and occupied slot monitoring",
      "Parking location management",
      "User-friendly mobile interface",
      "REST API integration",
    ],
    platforms: ["Android"],
    complexity: "Intermediate",
    duration: "2 months",
    teamSize: "1",
    impact:
      "Reduces the time and effort required to find parking by providing nearby parking discovery, slot availability, booking, and digital parking management in one platform.",
    liveUrl: "",
    githubUrl: "https://github.com/Ratnakar-Singh-parihar-123/ParkEasy",
    apkUrl: "/application-2b19fc59-78f1-4a7e-91b1-c437d35ac120.apk",
    apkStatus: "Available",
    status: "Planned",
    featured: true,
    iconColor: "from-blue-500 to-indigo-600",
    iconName: "Car",
  },
];

// ============================================================
// 🔗 MERGED LIST
// ============================================================
export const allProjects = [...webProjects, ...mobileAppsData];

// ============================================================
// ⭐ DERIVED HELPERS
// ============================================================
export const featuredProjects = allProjects.filter((p) => p.featured === true);

export const getProjectById = (id) =>
  allProjects.find((p) => String(p.id) === String(id)) || null;

export const getProjectsByType = (type) =>
  type === "all"
    ? allProjects
    : allProjects.filter((p) => p.projectType === type);

export const getProjectsByIndustry = (industry) =>
  allProjects.filter(
    (p) =>
      String(p.industry || "").toLowerCase() === String(industry).toLowerCase(),
  );

export const getProjectsByTech = (tech) => {
  const needle = String(tech || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "");
  return allProjects.filter((p) =>
    (p.technologies || []).some(
      (t) =>
        String(t)
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "") === needle,
    ),
  );
};

// ============================================================
// 📊 PORTFOLIO STATS
// ============================================================
export const portfolioStats = [
  {
    icon: "Layers",
    value: webProjects.filter((p) => p.projectType === "fullstack").length,
    label: "Full-Stack Apps",
    color: "primary",
    description:
      "Complete MERN stack applications with backend APIs, databases, and authentication",
  },
  {
    icon: "React",
    value: webProjects.filter((p) => p.projectType === "react").length,
    label: "React Projects",
    color: "blue",
    description:
      "Modern React applications with state management, responsive design, and interactive features",
  },
  {
    icon: "Code",
    value: webProjects.filter((p) => p.projectType === "htmlcss").length,
    label: "HTML/CSS Websites",
    color: "emerald",
    description:
      "Responsive websites built with pure HTML & CSS, focusing on clean design",
  },
  {
    icon: "Smartphone",
    value: mobileAppsData.length,
    label: "Mobile Apps",
    color: "purple",
    description:
      "Cross-platform mobile apps for iOS & Android built with React Native",
  },
];
